<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/onvEfU/tc-custom/9780759522855.jpg?1737194765154" alt="This image is the cover for the book Annie Lash"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Annie Lash
      </h1>
      <p class="bookDescription body article font2">
        <p>After the death of her parents, Annie Lash yearned for a man she could give her love to completely. Then a young frontiersman offered her a chance to escape her childhood home. When Annie arrives on the frontier, she discovers hostile Indians, river bandits, and a hidden passion that grows as the strong, young man who fought to tame the wild also begins to tame her stubborn heart.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dorothy Garlock
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WARNER BOOKS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bf2a6064